import { render, staticRenderFns } from "./SellerManagement.vue?vue&type=template&id=52e04462&scoped=true"
import script from "./SellerManagement.vue?vue&type=script&lang=js"
export * from "./SellerManagement.vue?vue&type=script&lang=js"
import style0 from "./SellerManagement.vue?vue&type=style&index=0&id=52e04462&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e04462",
  null
  
)

export default component.exports